import React from "react";
import { Card, CardBody, CardTitle, CardText } from "reactstrap";

const ContactDataCard = ({ title, data }) => {
  return (
    <>
      <CardTitle className="h5" style={{ color: "#555b21" }}>
        {title}
      </CardTitle>
      <Card className="shadow-sm">
        <CardBody>
          <dl className="row mb-0">
            {Object.entries(data).map(([key, value], index) => (
              <React.Fragment key={index}>
                <dt className="col-sm-3 font-weight-bold">{key} :</dt>
                <dd className="col-sm-9">
                  {value || <span className="text-muted">Non renseigné</span>}
                </dd>
              </React.Fragment>
            ))}
          </dl>
        </CardBody>
      </Card>
    </>
  );
};

export default ContactDataCard;
